import React from "react";
import { InputLabel, MenuItem, Select } from "@material-ui/core";
var areaName = function (a) { return a.name + " (" + a.country + ")"; };
export default (function (props) {
    var options = [];
    if (!props.notEmpty) {
        options.push(React.createElement(MenuItem, { key: "none", value: "none" }, "---"));
    }
    props.enterprise.areas.forEach(function (a) {
        var name = areaName(a);
        options.push(React.createElement(MenuItem, { key: name, value: name }, name));
    });
    var change = function (e) {
        var _a = e.target.value.split("("), name = _a[0], country = _a[1];
        if (!country) {
            props.onChange(undefined);
            return;
        }
        var area = {
            name: name.trim(),
            country: country.replace(")", "").trim(),
        };
        props.onChange(area);
    };
    return (React.createElement("div", { className: "col s12 m6" },
        React.createElement(InputLabel, null, "Target area"),
        React.createElement(Select, { className: "select", placeholder: "Area", name: "area", onChange: function (e) { return change(e); }, value: props.value ? areaName(props.value) : "none" }, options)));
});



//////////////////
// WEBPACK FOOTER
// ./src/components/common/AreaSelect.tsx
// module id = 570
// module chunks = 0